import BlocsInsertForm from "../../components/Blocs/BlocsInsertForm";




function BlocsAdd(){


    return (
        <BlocsInsertForm   ></BlocsInsertForm>
    );
}
export default BlocsAdd;